export default __webpack_public_path__ + "static/logoVNosotras-9e1f70a7e4678b9783c4953eb40eda65.png";